<template lang="html">
    <div id="page__no-forwarding__toolbar" class="tollbar__search report-forward-search" style="flex-grow: 3">
        <div class="text">
            <span> Для печати отчёта укажите параметры фильтрации </span>
        </div>
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset"  v-bind:disabled="!hasFilter"></z-icon-button>
        <z-icon-button v-bind:icon="['fa', 'gear']" rounded v-on:click="toggleFilter" primary-light  v-bind:disabled="!hasFilter"></z-icon-button>
        <div v-if="visibility" v-click-outside="hideFilter" class="md-elevation-2 dropdown">
            <div class="search-md-menu-container">
                <div class="filter-container md-layout">

                    <div class="center-layout md-layout-item md-size-20"> <label> Дата от </label> </div>
                    <div class="center-layout with-pr center-layout md-size-80 md-layout-item">
                        <z-date v-model="filter.date_from" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата от"> </z-date>
                    </div>
                    <div class="center-layout md-size-20 md-layout-item"> <label> Дата до </label> </div>
                    <div class="center-layout with-pr center-layout md-size-80 md-layout-item">
                        <z-date v-model="filter.date_to" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата до"> </z-date>
                    </div>
                    <div class="center-layout md-size-20 md-layout-item">
                        <label> Город экспедирования </label>
                    </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <ZInputAutocomplete
                            label="Город экспедирования (введите город)" placeholder="Любой"
                            display-property="label" property="id" id="report_filter_city_id" name="report_filter_city_id"
                            v-model="filter.city_id" v-bind:default="filter.city_label"
                            v-bind:callback="getCities" v-on:clear="clearCity" v-on:select="selectCity"
                        ></ZInputAutocomplete>
                    </div>
                    <div class="center-layout md-size-20 md-layout-item"> <label> НДС </label> </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <z-select v-model="filter.nds">
                            <option value="" selected> Любое </option>
                            <option v-bind:value="1"> с НДС </option>
                            <option v-bind:value="2"> без НДС </option>
                        </z-select>
                    </div>

                    <div class="center-layout md-size-20 md-layout-item"> <label> Исполнитель </label> </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <z-select v-model="filter.executor_id">
                            <option value="" selected> Любой </option>
                            <option
                                v-for="company in companies"
                                v-bind:value="company.id"
                                v-bind:key="`filter-executor-${company.id}`"
                            >{{ `${company.name} (НДС ${company.nds_value}%)` }}</option>
                        </z-select>
                    </div>

                    <div class="dropdown-button-container md-alignment-bottom-right md-size-100 md-layout-item">
                        <z-button v-on:click="doFilter" fit-content no-margin> Применить </z-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ZSelect from '@/components/ZSelect'
    import ClickOutside from 'vue-click-outside'
    import ZDate from '@/components/ZDate'
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    import MultyAutocomplete from '@/components/MultyAutocomplete';
    import ZButton from '@/components/ZButton.vue';
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: { ZSelect, ZDate, MultyAutocomplete, ZInputAutocomplete, ZButton, ZIconButton },
        directives: {ClickOutside},
        data() {
            return {
                visibility: false,
                filter: {
                    date_from: null,
                    date_to: null,
                    nds: null,
                    city_id: null,
                    city_label: null,
                    executor_id: null,
                },
                filterDefault: {
                    date_from: null,
                    date_to: null,
                    nds: null,
                    city_id: null,
                    city_label: null,
                    executor_id: null,
                },
            }
        },
        created() {
            this.init();
            if (this.$route.query && this.$route.query.custom_filter)
                this.filter = Object.assign({}, JSON.parse(this.$route.query.custom_filter));
                
            this.$root.$emit('refresh-table', 'report-noforwarding');
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).find(item => !!item);
            },
            companies() {
                return this.$store.state.companies.companies;
            },
        },
        methods: { 
            /**
             * Инициализация компонента
             */
            init() {
                this.getCompanies();
                this.filter.date_from = this.moment().tz(this.$root.userTimezone).subtract(1,'months').startOf('month').toDate();
                this.filter.date_to   = this.moment().tz(this.$root.userTimezone).subtract(1,'months').endOf('month').toDate();
            },
            /**
             * Скрыть фильтр
             */
            hideFilter() {
                this.visibility = false;
            },
            /**
             * Переключение фильтра
             */
            toggleFilter() {
                this.visibility = !this.visibility;
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                this.init();
                this.doFilter();
            },
            /**
            * Применение фильтра
            */
            doFilter() {
                this.$nextTick(() => {
                    let query = Object.assign({}, this.$route.query);
                    if (!query) query = {};
                    query.custom_filter = JSON.stringify(Object.assign({}, this.filter));
                    this.$router.push({ name: this.$route.name, params: this.$route.params, query: query});
                    this.$root.$emit('refresh-table', 'report-noforwarding');
                    this.hideFilter();
                });
            },
            /**
             * Очистка города
             */
            clearCity() {
                this.filter.city_id = null;
                this.filter.city_label = null;
            },
            /**
             * Выбор города
             */
            selectCity(id, city) {
                this.filter.city_id    = city.value;
                this.filter.city_label = city.label;
            },
            /**
             * Получение городов
             */
            getCities(value) {
                if (!value || value.length < 3) return new Promise(resolve => resolve([]));
                let filter = {model: [['name', '%', value]]};
                return this.$store.dispatch('cost/getCitiesNew', {page: 1, order_by: 'name', order_type: 'asc', count: 20, filter: filter}).then(result => {
                    if (!result || !result.data) return [];
                    return result.data.map(city => {
                        city.value = city.id;
                        city.label = city.name;
                        return city;
                    });
                });
            },
            getCompanies() {
                return this.$store.dispatch('companies/getCompanies', { cache: true });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// NoForwardingToolbar.vue?194ac626